import React, { useState, Fragment } from "react";
import { Grid } from "@material-ui/core";

import Page from "../layouts/pages/PageLayout";
import CreateCommunity from "../components/forms/community/CreateForm";
import SpeedDialButton from "../components/SpeedDialButton";
import Business from "@material-ui/icons/Business";
import Header from "../layouts/headers/pages/AdminHeaderLayout";
import { constantsApp } from "../constants/constants.app";

function AdminPage() {
  const [state, setState] = useState({
    showFormCommunity: false,
    showForm: false
  });

  const buttons = [
    {
      id: "add",
      title: constantsApp.pages.adminPage.ADD_COMMUNITY_BUTTON,
      icon: <Business />,
      action: () => toggleForm("showFormCommunity")
    }
  ];

  const toggleForm = action =>
    setState(prevState => {
      prevState[action] = !prevState[action];
      return { ...prevState };
    });
  const { showFormCommunity } = state;

  return (
    <Page header={<Header toggleForm={toggleForm} />}>
      <Grid container justify="center" alignItems="center">
        {showFormCommunity && (
          <Fragment>
            {/* <Grid item xs={12} lg={8}>
              <Typography variant="h5" color="secondary">
                Create Community
              </Typography>
            </Grid> */}
            <Grid item xs={12} lg={8}>
              <CreateCommunity onCancel={toggleForm} />
            </Grid>
          </Fragment>
        )}
        <SpeedDialButton
          toggleForm={toggleForm}
          hidden={state.showForm}
          buttons={buttons}
        />
      </Grid>
    </Page>
  );
}

export default AdminPage;
